export const PRODUCT_OPTION_LABELS = {
  rating: 'Rating',
  weight: 'Weight'
};

export const PRODUCT_OPTION_FIELDS = Object.keys(PRODUCT_OPTION_LABELS);

export const PRODUCT_OPTION_PRESETS = {
  weight: ['0.1', '0.25', '0.5', '1', '2'],
  rating: ['1', '2', '3', '4', '5']
};

export const WEIGHT_LABELS = {
  '0.1': '100g',
  '0.25': '250g',
  '0.5': '500g',
  '1': '1kg',
  '2': '2kg',
};
